import type { ReactNode } from 'react'
import type { BadgeVariant } from '../types'

interface BadgeProps {
  variant: BadgeVariant
  children: ReactNode
  className?: string
  size?: 'sm' | 'md' | 'lg' | string
}

const badgeClasses: Record<BadgeVariant, string> = {
  success: 'bg-[#166534]/15 text-[#166534]',
  info: 'bg-[#1d4ed8]/15 text-[#1d4ed8]',
  warning: 'bg-[#e07e17]/15 text-[#e07e17]',
  danger: 'bg-[#b91c1c]/15 text-[#b91c1c]',
  neutral: 'bg-[#64748b]/15 text-[#475569]',
  teal: 'bg-[#ccfbf1] text-[#0a5b63]',
}

export function Badge({ variant, children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full h-6 px-2.5 text-[10px] font-medium leading-none whitespace-nowrap ${badgeClasses[variant]} ${className}`}
    >
      {children}
    </span>
  )
}
